var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.animation,"tag":"div"}},[(_vm.show)?_c('ui-layout',{class:_vm.classes,attrs:{"aria-hidden":true,"type":"grid","align":"place-center","gap":"0"}},[_c('span',{staticClass:"spinner__inner"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }